import {initializeApp} from 'firebase/app';
import {getMessaging, isSupported, Messaging} from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyDrRdsdYYepS172PKsCUwM634smAw9YLfY',
  authDomain: 'usc-cabinet.firebaseapp.com',
  databaseURL: 'https://usc-cabinet.firebaseio.com',
  projectId: 'usc-cabinet',
  storageBucket: 'usc-cabinet.appspot.com',
  messagingSenderId: '913287409538',
  appId: '1:913287409538:web:6de154f9316bcb4e3b699b',
  measurementId: 'G-BEWRS2GHFS',
};

export const vapidKey = 'BIrLT1f4Kp8hGRJaae0deNM56grqZAsfiwiSgr8nKhX0DIwn5PLfEKTjOvNHMcenc_13-3zGDCYqyZbzaAZeu7o';

const app = initializeApp(firebaseConfig);

let messaging: Messaging | null = null;
isSupported().then((supported) => {
  if (supported) {
    messaging = getMessaging(app);
  }
});

export {messaging};
